import React, { Fragment } from "react";
import LogsList from "../../pages/logs/LogsList";
const Logs = (props) => {
    const { fetchURL, onCheckUserPrivilage, dataList, onGetDataList, numberOfRecords, currentPage, onChangeNOR, onResizeWindow, activeEvent, onChangeNavAndPage, onShowAlert, t, onShowHomePage } =
        props;
    return (
        <Fragment>
            {currentPage.nav === "logs" && (
                <Fragment>
                    {currentPage.subpage === "logsList" && (
                        <LogsList
                            onResizeWindow={onResizeWindow}
                            fetchURL={fetchURL}
                            onCheckUserPrivilage={onCheckUserPrivilage}
                            onChangeNavAndPage={onChangeNavAndPage}
                            currentPage={currentPage}
                            activeEvent={activeEvent}
                            onShowAlert={onShowAlert}
                            dataList={dataList}
                            onGetDataList={onGetDataList}
                            numberOfRecords={numberOfRecords}
                            onChangeNOR={onChangeNOR}
                            eventFilterValue={props.eventFilterValue}
                            eventsList={props.eventsList}
                            onChangeEventFilter={props.onChangeEventFilter}
                            t={t}
                            onShowHomePage={onShowHomePage}
                        />
                    )}
                </Fragment>
            )}
        </Fragment>
    );
};

export default Logs;
